webpackJsonp([254572558124955],{

/***/ 794:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"YW3V619FID","searchOnlyApiKey":"284a94d9daae988d84aaccfa73bb2045","indexName":"content"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-585f201320c4fca72275.js